import { render } from "./DynamicSubmitScenarioResource.vue?vue&type=template&id=6468ef9b&scoped=true"
import script from "./DynamicSubmitScenarioResource.vue?vue&type=script&lang=js"
export * from "./DynamicSubmitScenarioResource.vue?vue&type=script&lang=js"

import "./DynamicSubmitScenarioResource.vue?vue&type=style&index=0&id=6468ef9b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6468ef9b"

export default script